import {NavLink} from 'react-router-dom';
import {
    Box,
    Breadcrumbs,
} from '@mantine/core';

import config from '../config';

// ⚠️ A FLAT TRAIL, unlike the records module's.
//
// A certificate is a tenant-owned asset in its own right — it is listed by
// tenant, not by zone, and `listCertificates` takes no zone argument. So the
// trail is Home → Certificates, with no intermediate zone to pass through.
export const IndexPageNavigation = () => {

    const breadcrumbs = [
        {
            title: 'Home',
            href: '/dashboard',
        },
        {title: config.titles.plural},
    ].map((item, index) => (
        <Box key={index}>
            {item.href ? <NavLink to={item.href}>{item.title}</NavLink> : item.title}
        </Box>
    ));

    return (
        <Box p={'xs'}><Breadcrumbs separator='→' mt='xs'>{breadcrumbs}</Breadcrumbs></Box>
    );
};
